export default "__VITE_ASSET__599372df__"